import { render, staticRenderFns } from "./creatives-table.vue?vue&type=template&id=83bf8f22&scoped=true"
import script from "./creatives-table.vue?vue&type=script&lang=js"
export * from "./creatives-table.vue?vue&type=script&lang=js"
import style0 from "./creatives-table.vue?vue&type=style&index=0&id=83bf8f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bf8f22",
  null
  
)

export default component.exports